import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Spinner from "views/lib/components/Spinner";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getSingle } from "actions/chargers/station/actions";

import filterTypes from "../../../../../data/filter-types";
import SingleInfo from "./info";

const ChargerSingle = (props) => {
  const {
    getSingle,
    match,
  } = props;
  const { id } = match.params;

  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({});

  useEffect(() => {
    setLoading(true);
    getSingle([{
      fieldName: "qr",
      fieldValue: id,
      searchOperation: filterTypes.EQUALS.value
    }], (response) => {
      setLoading(false);
      if (!response || !response.content || !response.content[0]) {
        return;
      }
      setItem(response.content[0]);
    });
  }, [getSingle, id]);

  return (
    <div className="m-2 position-relative">
      {!loading || <Spinner/>}

      {Object.keys(item).length ? (
        <SingleInfo value={item}/>
      ) : null}
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.charger.loading,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getSingle: bindActionCreators(getSingle, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ChargerSingle);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/single/index.js